export interface StockAdjustmentInfo {
  adjusted: boolean
  reason: 'stock' | 'promotion' | 'max' | null
  productName: string
  originalQuantity: number
  newQuantity: number
}

export interface StockAlertInitialState {
  stockAdjusted: StockAdjustmentInfo
  setStockAdjusted: (info: StockAdjustmentInfo) => void
}

export const stockAlertInitialState: StockAlertInitialState = {
  stockAdjusted: {
    adjusted: false,
    reason: null,
    productName: '',
    originalQuantity: 0,
    newQuantity: 0,
  },
  setStockAdjusted(info) {},
}
